import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { SingleSelectCombobox } from "src/components/SingleSelectCombobox";
import type { ExercisePrimaryMuscleGroupsComboboxProps } from "src/exercise/ExerciseMuscleSecondaryGroupsCombobox";
import { useExerciseMuscleGroups } from "src/state/exerciseMuscleGroups";
import { type TranslationKey } from "src/types";

export const ExercisePrimaryMuscleGroupCombobox = observer(
  function ExercisePrimaryMuscleGroupCombobox(
    props: ExercisePrimaryMuscleGroupsComboboxProps,
  ) {
    const exerciseMuscleGroups = useExerciseMuscleGroups();
    const { t } = useTranslation();

    const items = exerciseMuscleGroups.muscleGroupsList.map((mg) => {
      return {
        id: mg.id,
        label: t(`muscleGroups.${mg.name}` as TranslationKey),
      };
    });

    return (
      <SingleSelectCombobox
        items={items}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        emptyText="No muscles found"
      />
    );
  },
);
